import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('components.AddBillInvoicesPopup.EmptyState', {
    emptyText: 'No matching bills found',
});
